import { InjectionToken } from '@angular/core';

import { BusinessDictionariesApi } from './dictionaries-api.interface';

export const BUSINESS_DICTIONARIES_API = new InjectionToken<BusinessDictionariesApi>('BUSINESS_DICTIONARIES_API');
